import { Component, OnInit, ViewChild, AfterViewInit, HostBinding, HostListener, Input } from '@angular/core';
import { COLORS } from '../../../shared/colors';
import { BarVerticalComponent } from '@swimlane/ngx-charts';
import { StatisticService } from '../../../shared/services/statistic.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-achievement-activity',
  templateUrl: './activity-achievement.component.html',
  styleUrls: ['./activity-achievement.component.scss'],
})
export class ActivityAchievementComponent implements AfterViewInit {
  showDay: boolean = true;
  showWeek: boolean = false;
  showMonth: boolean = false;

  data = [
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
  ];

  dataWeek = [
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
  ];
  dataMonth = [
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
  ];

  todayProgress: number = 0;
  weeklyProgress: number = 0;

  week: string[] = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  @ViewChild('chart') chart: BarVerticalComponent;
  constructor(private stats: StatisticService, private translate: TranslateService) {
    stats.getMyStatistic().then((statistics) => {
      let todayTimeStamp = moment();
      this.dataWeek = [];
      for (let day = 0; day < 7; day++) {
        this.dataWeek.unshift({
          name: todayTimeStamp.day().toString(),
          value: statistics[day] || 0,
        });
        todayTimeStamp = todayTimeStamp.subtract(1, 'days');
        if (statistics[day] >= 6) {
          this.weeklyProgress++;
        }
      }
      this.data = this.dataWeek;
      this.updateChartDimensions();
      this.todayProgress = statistics[0];

      todayTimeStamp = moment();

      for (let day = 0; day < 31; day++) {
        if (todayTimeStamp.month() === moment().month() || todayTimeStamp.date() > moment().date()) {
          this.dataMonth.unshift({
            name: todayTimeStamp.date().toString(),
            value: statistics[day] || 0,
          });
          todayTimeStamp = todayTimeStamp.subtract(1, 'days');
        }
      }

      translate.get('GENERAL.daysShort').subscribe((res: string[]) => {
        for (const d of this.dataWeek) {
          d.name = res[d.name];
        }
        if (this.showWeek) {
          this.data = this.dataWeek;
        }
      });
    });
  }

  ngAfterViewInit() {
    this.updateChartDimensions();
  }

  @HostListener('window:resize')
  resizeBy() {
    setTimeout(() => {
      this.updateChartDimensions();
    }, 300);
  }

  yAxisFormatting(value: number) {
    return value.toString();
  }

  mapToPercentage() {
    const percentage = (this.todayProgress / 6) * 100;
    return Math.min(Math.max(percentage, 0), 100);
  }

  updateChartDimensions() {
    if (this.chart && this.chart.dims) {
      this.chart.barPadding = this.chart.dims.height / (this.data.length - 1) - 30;
      this.chart.update();
    } else {
      setTimeout(this.updateChartDimensions, 300);
    }
  }

  colorScheme = {
    domain: ['#E6A43D'],
  };

  toggleDay() {
    this.data = this.dataWeek;
    this.showDay = true;
    this.showWeek = false;
    this.showMonth = false;
  }

  toggleWeek() {
    this.data = this.dataWeek;
    this.showDay = false;
    this.showMonth = false;
    this.showWeek = true;

    this.updateChartDimensions();
  }

  toggleMonth() {
    this.data = this.dataMonth;
    this.showWeek = false;
    this.showDay = false;
    this.showMonth = true;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity-achievement/activity-achievement.component.ts